import React, { useState, useEffect, useContext } from "react";
import styles from "./Market.module.sass";
import Row from "./Row";
import { getProducts } from "../../../../../Firebase/firebaseDatabase";
import {
  collection,
  getDocs,
} from "@firebase/firestore";
import { db } from '../../../../../Firebase/firebaseConfig';
import { GlobalState } from "../../../../../App";
import LoadingIndicator from "../../../../../LoadingScreen/LoadingIndicator";
import Icon from "../../../../../components/Icon";

const Market = ({ searchBy }) => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setNewProductList([])
  }, [])

  const [selectedFilters, setSelectedFilters] = useState([]);
  const { categories, isClickedSave, homeCustomProducts, newProductList, setNewProductList } = useContext(GlobalState);

  const handleChange = (id) => {
    if (selectedFilters.includes(id)) {
      setSelectedFilters(selectedFilters.filter((x) => x !== id));
    } else {
      setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
    }
  };

  const [isPrevActive, setIsPrevActive] = useState(false)
  const [isNextActive, setIsNextActive] = useState(true)
  const [activePageNum, setActivePageNum] = useState(1)
  const [pageCount, setPageCount] = useState(1)

  const page_items_count = 50;
  const [range, setRange] = useState({
    start: 0,
    end: page_items_count
  })

  const [itemsList, setItemsList] = useState([])

  const calculatePageCount = (active_products) => {
    const calculated_page_count = active_products.length / page_items_count;
    const check_if_isInteger = Number.isInteger(calculated_page_count)
    if (check_if_isInteger) {
      setPageCount(calculated_page_count)
      setLoading(false)
      if (calculated_page_count === 1) {
      }
    } else {
      setPageCount(Math.floor(calculated_page_count) + 1)
      setLoading(false)
      if (Math.floor(calculated_page_count) + 1 === 1) {
      }
    }
  }

  const fetchProducts = async () => {

    await getProducts().then(async (data) => {

      data.forEach(async (element, index) => {
        categories.forEach((category, i) => {
          if (category.id === element?.data?.category) {
            element.data.category = category?.data?.titleEn
          }
        })
        await getDocs(
          collection(db, "product", element?.id, "variation")
        )
          .then(async (doc) => {
            const variationDetails = doc.docs.map((doc) => ({
              data: doc.data(),
              id: doc.id,
            }));
            if (variationDetails.length === 0) {
              setNewProductList((oldData) => [...oldData, element])
            }
            else {
              variationDetails.forEach(async (variationData, i) => {
                // add poduct data in variation data of that product
                variationData.product = element;
                variationData.data.images = variationData.data.images[0]

                homeCustomProducts.forEach((globalHomeCstmPrdct, index) => {
                  if (globalHomeCstmPrdct?.id === variationData?.id) {
                    variationData.selected = true
                  }
                });
                setNewProductList((oldData) => [...oldData, variationData])
              })
            }
          })
          .catch((e) => {

          });
      });

    }
    )
  }

  useEffect(() => {
    setLoading(true)
    fetchProducts()

  }, []);

  useEffect(() => {
    const updatedProdList = newProductList.sort(function (x, y) {
      return (x.selected === y.selected) ? 0 : x.selected ? -1 : 1;
    })
    setItemsList(updatedProdList)
    calculatePageCount(updatedProdList);
  }, [newProductList]);

  useEffect(() => {
    const active_products = newProductList.filter(data => {
      if (data.data.sku === searchBy) {
        return data
      } else {
        if (data.product.data.titleEn.toLowerCase().includes(searchBy.toLowerCase())) {
          return data
        }
      }
    })
    setItemsList(active_products)
    calculatePageCount(active_products);
  }, [searchBy]);

  useEffect(() => {

  }, [isClickedSave])

  const handleChangePrevClick = () => {

    if (activePageNum > 1) {
      setIsNextActive(true)
      const updatedPageNum = activePageNum - 1;
      setActivePageNum(updatedPageNum)

      if (updatedPageNum === 1) {
        setIsPrevActive(false)
      } else {
        setIsPrevActive(true)
      }

      setRange({
        start: updatedPageNum * page_items_count - page_items_count,
        end: updatedPageNum * page_items_count
      })
    } else {
      setIsPrevActive(false)
    }
  }

  const handleChangeNextClick = () => {

    if (activePageNum < pageCount) {
      setIsPrevActive(true)
      const updatedPageNum = activePageNum + 1;
      setActivePageNum(updatedPageNum);

      if (updatedPageNum === pageCount) {
        setIsNextActive(false)
      } else {
        setIsNextActive(true)
      }

      setRange({
        start: updatedPageNum * page_items_count - page_items_count,
        end: updatedPageNum * page_items_count
      })

    } else {
      setIsNextActive(false)
    }
  }

  return (
    <div className={styles.market}>
      {
        loading ?
          <div className={styles.loadingContainer}>
            <LoadingIndicator />
          </div>
          : <>
            <div className={styles.table}>
              <div className={styles.row}>
                <div className={styles.col}></div>
                <div className={styles.col}>Title</div>
                <div className={styles.col}>SKU</div>
                <div className={styles.col}>Category</div>
                <div className={styles.col}>Price</div>
                <div className={styles.col}>Qty</div>
                <div className={styles.col}>Status</div>
              </div>
              {
                itemsList
                  ?.map((x, index) => {
                    return (
                      (index >= range.start) && (index < range.end) ?
                        <Row
                          item={x}
                          indexVal={index}
                          up={newProductList.length - index <= 2}
                          value={selectedFilters.includes(x.id)}
                          onChange={() => handleChange(x.id)}
                        /> : <></>
                    )
                  })
              }
            </div>

            {
              pageCount !== 0 && pageCount !== 1 ?
                <div className={styles.foot}>
                  <button
                    style={{
                      opacity: isPrevActive ? 1 : 0.1
                    }}
                    onClick={() => {
                      handleChangePrevClick()
                    }} className={styles.arrow}>
                    <Icon name="arrow-left" size="20" />
                  </button>

                  <button
                    style={{
                      opacity: isNextActive ? 1 : 0.1
                    }}
                    onClick={() => {
                      handleChangeNextClick()
                    }} className={styles.arrow}>
                    <Icon name="arrow-right" size="20" />
                  </button>
                </div>
                : <></>
            }
          </>
      }

    </div>
  );
};

export default Market;
